/*----------------------------------------------------------------------
    Function: fetchModules                                           
----------------------------------------------------------------------*/
async function fetchModules() {
    const payload = { cms_internal: '1' };
    const response = await fetch(window.cmsRoutes.apiListModules, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-Cms-Internal-Token': window.cmsInternalToken // stored globally
        },
        cache: 'no-cache',
        credentials: 'same-origin',
        body: JSON.stringify(payload)
    });

    if (!response.ok) throw new Error('Failed to load modules');

    return response.json();
}

/*----------------------------------------------------------------------
    Function: buildSidebar                                           
----------------------------------------------------------------------*/
function buildSidebar(modules) {
    const sidebar = document.getElementById('cms-sidebar');
    sidebar.innerHTML = '';

    // Add logo image at top
    const logo = document.createElement('img');
    logo.className = 'sidebar-logo';
    logo.src = '/cmsApp/public/images/ncms_logo.webp'; // <-- INSERT IMAGE URL HERE
    logo.alt = 'CMS Logo';
    sidebar.appendChild(logo);
    const grouped = {};
    const ungrouped = [];

    modules.forEach((mod) => {
        if (mod.group) {
            if (!grouped[mod.group]) grouped[mod.group] = [];
            grouped[mod.group].push(mod);
        } else {
            ungrouped.push(mod);
        }
    });

    const currentPath = decodeURIComponent(window.location.pathname);

    // Render ungrouped modules
    ungrouped.forEach((mod) => {
        const item = document.createElement('a');
        item.className = 'menu-item';
        item.dataset.module = mod.route;
        item.href = `/cmsApp/module/${mod.route}`;
        item.innerHTML = mod.icon ? `${mod.icon} <span>${mod.title}</span>` : `<span>${mod.title}</span>`;

        if (currentPath.includes(`/module/${mod.route}`)) {
            item.classList.add('active');
        }

        sidebar.appendChild(item);
    });

    // Render grouped modules
    Object.entries(grouped).forEach(([groupName, groupModules]) => {
        const groupWrapper = document.createElement('div');
        groupWrapper.className = 'menu-group';

        const groupToggle = document.createElement('div');
        groupToggle.className = 'menu-group-toggle';
        groupToggle.innerHTML = `<span class="link">${groupName}</span><i class="fa fa-chevron-down"></i>`;
        groupToggle.addEventListener('click', () => {
            groupWrapper.classList.toggle('expanded');
        });

        const groupContent = document.createElement('div');
        groupContent.className = 'menu-group-content';

        groupModules.forEach((mod) => {
            const item = document.createElement('a');
            item.className = 'menu-item';
            item.dataset.module = mod.route;
            item.href = `/cmsApp/module/${mod.route}`;
            item.innerHTML = mod.icon ? `${mod.icon} <span>${mod.title}</span>` : `<span>${mod.title}</span>`;

            if (currentPath.includes(`/module/${mod.route}`)) {
                item.classList.add('active');
                groupWrapper.classList.add('expanded', 'has-active');
            }

            groupContent.appendChild(item);
        });

        groupWrapper.appendChild(groupToggle);
        groupWrapper.appendChild(groupContent);
        sidebar.appendChild(groupWrapper);
    });
}

/*----------------------------------------------------------------------
    Function: getCurrentModuleName
----------------------------------------------------------------------*/
function getCurrentModuleName() {
    const path = decodeURIComponent(window.location.pathname);
    const parts = path.split('/');
    const moduleIndex = parts.indexOf('module');
    if (moduleIndex !== -1 && parts.length > moduleIndex + 1) {
        return parts[moduleIndex + 1];
    }
    return null;
}

/*----------------------------------------------------------------------
    Function: initModuleAssets
----------------------------------------------------------------------*/
async function initModuleAssets() {
    const moduleName = getCurrentModuleName();
    if (moduleName && window.__cmsSystem) {
        await window.__cmsSystem.init([moduleName]);
    }
}

/*----------------------------------------------------------------------
    Function: initCMS
----------------------------------------------------------------------*/
async function initCMS() {
    try {
        const modules = await fetchModules();
        buildSidebar(modules);

        const path = decodeURIComponent(window.location.pathname);
        const parts = path.split('/');
        const moduleIndex = parts.indexOf('module');
        const currentModule = moduleIndex !== -1 && parts.length > moduleIndex + 1 ? parts[moduleIndex + 1] : null;

        if (!currentModule) {
            window.location.href = `${window.cmsRoutes.routeModule}Dashboard`;
        } else {
            await initModuleAssets();
        }
    } catch (err) {
        const container = document.getElementById('cms-main');
        if (container) {
            container.innerHTML = `<p class="error">Failed to initialize CMS. ${err}</p>`;
        }
    }
}

document.addEventListener('DOMContentLoaded', initCMS);
